export default {
  LOWER_THAN_CTE: {
    value: 'LOWER_THAN_CTE',
    label: 'Valor TMS menor que Valor CTe',
  },
  EQUAL_OR_LOWER_THAN_CTE: {
    value: 'EQUAL_OR_LOWER_THAN_CTE',
    label: 'Valor TMS igual ou menor que Valor CTe',
  },
  EQUAL_CTE: {
    value: 'EQUAL_CTE',
    label: 'Valor TMS igual ao Valor CTe',
  },
  GREATER_THAN_CTE: {
    value: 'GREATER_THAN_CTE',
    label: 'Valor TMS maior que Valor CTe',
  },
  EQUAL_OR_GREATER_THAN_CTE: {
    value: 'EQUAL_OR_GREATER_THAN_CTE',
    label: 'Valor TMS igual ou maior que Valor CTe',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-generation/enums/EnumDifferenceValues.js